<template>
  <div v-if="display">
    <modal-layout-top :title="title" />

    <div class="content slider-modal">

      <div class="field">
        <label class="label">Namn</label>
        <input class="input" type="text" v-model="deliveryTemplate.name" required />
      </div>

      <hr>

      <h4>Insatser</h4>

      <table class="table is-fullwidth is-narrow">
        <thead>
          <tr>
            <th>Extern not</th>
            <th>Taxor</th>
            <th>Hyror</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in deliveryTemplate.items" :key="item.deliveryTemplateItemId">
            <td><input type="text" class="input is-small" v-model="item.invoiceNote"></td>
            <td><input type="number" class="input is-small" :value="getNumberOfItems(item, 'Rate')" disabled></td>
            <td><input type="number" class="input is-small" :value="getNumberOfItems(item, 'Rent')" disabled></td>
            <td>
              <button class="button is-small" @click="openDeliveryTemplateItemModal(item)">Rader</button>
              <span class="remove-item" @click="confirmRemoveDeliveryTemplateItem(item)">-</span>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="add-new-item" @click="addDeliveryTemplateItem()">+</div>

      <hr class="separator">

      <modal-layout-buttons :store-name="'deliveryTemplates'" />

    </div>

  </div>
</template>

<script>

import { mapActions } from 'vuex'
import DeliveryTemplateItemModal from '@/components/modals/DeliveryTemplateItemModal'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  name: 'delivery-template-modal',
  data () {
    return {
      deliveryTemplate: {
        items: []
      },
      isUpdate: false,
      display: false,
      products: []
    }
  },
  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },
  props: {
    deliveryTemplateId: {
      type: Number,
      required: false
    }
  },
  methods: {
    ...mapActions('deliveryTemplates', ['update', 'create', 'getById']),
    ...mapActions('products', {
      getAllProducts: 'getAll'
    }),

    closePanel () {
      this.$emit('closePanel')
    },

    getNumberOfItems (item, productType) {
      const lines = item.lines.filter(x => x.productType === productType)
      return (lines && lines.length) ? lines.length : '0'
    },

    save () {
      if (!this.deliveryTemplate.name) {
        this.$toast('Du måste ge leveransmallen ett namn', 'error')
        return
      }

      if (!this.deliveryTemplate.items || this.deliveryTemplate.items.length === 0) {
        this.$toast('Du måste lägga till minst en insats', 'error')
        return
      }

      if (this.deliveryTemplate.deliveryTemplateId) {
        this.update(this.deliveryTemplate).then(() => {
          this.closePanel()
        }).catch(() => {
          this.$toast('Felaktig data', 'error')
        })
      } else {
        this.create(this.deliveryTemplate).then(() => {
          this.closePanel()
        })
      }
    },

    addDeliveryTemplateItem () {
      for (let item of this.deliveryTemplate.items) {
        if (!item.lines || item.lines.length === 0) {
          this.$toast('Du har redan en tom insats', 'error')
          return
        }
      }

      this.deliveryTemplate.items.push({
        invoiceable: true,
        lines: []
      })
    },

    confirmRemoveDeliveryTemplateItem (deliveryTemplateItem) {
      if (deliveryTemplateItem.lines && deliveryTemplateItem.lines.length > 0) {
        this.$confirm('Radera insatsen', 'Är du säker på att du vill radera insatsen? Alla insatsrader kommer också att försvinna.').then((result) => {
          if (result.value) {
            this.removeDeliveryTemplateItem(deliveryTemplateItem)
          }
        })
      } else {
        this.removeDeliveryTemplateItem(deliveryTemplateItem)
      }
    },

    removeDeliveryTemplateItem (deliveryTemplateItem) {
      this.deliveryTemplate.items = this.deliveryTemplate.items.filter(x => x !== deliveryTemplateItem)
    },

    openDeliveryTemplateItemModal (deliveryTemplateItem) {
      this.$panel(DeliveryTemplateItemModal, { deliveryTemplateItem, products: this.products })
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    let promises = []

    if (!this.deliveryTemplateId) {
      this.isUpdate = false
    } else {
      promises.push(this.getById(this.deliveryTemplateId).then((deliveryTemplate) => {
        this.deliveryTemplate = deliveryTemplate
      }))
      this.isUpdate = true
    }

    promises.push(this.getAllProducts().then((products) => {
      this.products = products
    }))

    Promise.all(promises).then(() => {
      if (!this.isUpdate) {
        this.title = 'Skapa ny leveransmall'
      } else {
        this.title = 'Ändra ' + this.deliveryTemplate.name.toString()
      }
      this.display = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/DeliveryTemplateModal.vue